
import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import ContactLinkItem from './ContactLinkItem'; // Import the ContactLinkItem component

const ContactLinksCategorySection = ({ categoryTitle, items, onContactLinkButtonClick }) => {
  const sortedItems = [...items].sort((a, b) => a.localeCompare(b));

  return (
    <Box sx={{ mb: 4 }}>
      {/* Category Title */}
      <Typography
        variant="body2"
        sx={{
          fontSize: '0.75rem',
          fontWeight: 'bold',

          mb: 2, // Margin bottom for spacing
          textAlign: 'left', // Left align the title
        }}
      >
        {categoryTitle}
      </Typography>

 {/* Buttons */}
 <Grid container spacing={1} sx={{ justifyContent: 'flex-start' }}>
        {sortedItems.map((item) => (
          <Grid item xs={12} sm={4} md={3} key={item}>
            <ContactLinkItem
              text={item}
              onClick={() => onContactLinkButtonClick(item)}
              type={item}
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ContactLinksCategorySection;